import { baseURL } from "@/api";
import { MapProducts } from "@/api/products/mapProducts";
import { useEffect, useState } from "react";
import { Empty } from "./empty";
import { useParams } from "react-router-dom";
import { OfferReturn } from "@/api/offers";
import { Plan } from "@/api/products";
import { ProductPage } from "./ProductPage";
import { Loading } from "@/components/Loading";

export function PlanPage() {
  const params = useParams();
  const [isLoaded, setIsLoaded] = useState(false);
  const [offer, setOffer] = useState<OfferReturn | null>(null);
  const [products, setProducts] = useState<Plan[]>([]);

  useEffect(() => {
    Promise.all([
      fetch(`${baseURL}/core/ofertas/${params.id}`).then((res) => res.json()),
      fetch(`${baseURL}/core/planos/`)
        .then((res) => res.json())
        .then((data) => MapProducts(data)),
    ])
      .then(([_offer, _products]) => {
        setOffer(_offer);
        setProducts(_products);
        setIsLoaded(true);
      })
      .finally(() => {
        setIsLoaded(true);
      });
  }, [params.id]);

  if (!isLoaded) {
    return <Loading src="/tim_logo.svg" />;
  }

  if (!offer || (offer && products?.length === 0)) {
    return <Empty />;
  }

  const offerProduct = products.find(
    (product) =>
      product.tim_id === offer.tim_id &&
      product.precos.find((price) => price.ddd === offer.ddd)
  );

  if (!offerProduct) {
    return <Empty />;
  }

  return <ProductPage offer={offer} ofertaSlug={params.id ?? ""} />;
}
export default PlanPage;
